import { useParams } from "react-router-dom";
import InvoicePDFBase from "./components/Base";
import HeaderBack from "@/components/fragments/HeaderBack";

export default function InvoicePDFPage() {
  const { outNo } = useParams<{ outNo: string }>();

  return (
    <div className="max-w-lg mx-auto bg-white">
      <HeaderBack text="" url={`/activity/${outNo}`} />
      <InvoicePDFBase outNo={outNo} />;
    </div>
  );
}
